import React from 'react';
import './App.css';
import MapComponent from './components/Map';

function App() {
  return (
      <div className="App">
          <MapComponent/>
      </div>
  );
}

export default App;
